import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { memo, useState } from "react";
import { DefaultForm } from "../../components";
import { GlanceHistoryType } from "../../entities/enums";
import { GlanceHistoryCollectModel } from "../../entities/glance";
import { useGetCompaniesSelectFilterQuery } from "../../features/api/apiSlice";

interface GlanceHistoryCollectorProps {
  collectCallback: (data: GlanceHistoryCollectModel) => Promise<boolean>;
}

export const GlanceHistoryCollector = memo(({ collectCallback }: GlanceHistoryCollectorProps) => {
  const [isCollecting, setIsCollecting] = useState(false);

  let model: GlanceHistoryCollectModel = {
      symbols: [],
      historyType: GlanceHistoryType.Trades,
      cookie: ""
  };

  const onFinish = async (values: any) => {
    let collectModel: GlanceHistoryCollectModel = {
      ...values
    };

    setIsCollecting(true);

    await collectCallback(collectModel);

    setIsCollecting(false);
  };

  return (
    <DefaultForm onFinish={onFinish} layout="vertical" initialValues={model}>
      <DefaultForm.DataSelect name="symbols" label="none" placeholder="انتخاب شرکت ها" multiple={true} recordId={x=>x.symbol} wrapperCol={{xs: 24, lg: 12}}
        query={useGetCompaniesSelectFilterQuery}
        displayText={(x) => `${x.symbol} (${x.name})`}
        isPersian={true}
      />

      <DefaultForm.EnumSelect name="historyType" type={GlanceHistoryType} wrapperCol={{xs: 24, md: 12, lg:6}} />

      <DefaultForm.TextInput name="cookie" wrapperCol={{xs: 24, md: 12, lg:6}} />

      <DefaultForm.SubmitButton loading={isCollecting} icon={<FontAwesomeIcon className="anticon" icon={faPlusCircle} />}>
          کالکت
      </DefaultForm.SubmitButton>
    </DefaultForm>
  );
});
